
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import Attribute from '@/components/Attribute'
import AttributeModel from '@/models/Attribute'
import CharacterModel from '@/models/Character'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"attribute"}}>{`Attribute`}</MDXTag>
<MDXTag name="p" components={components}>{`The `}<MDXTag name="inlineCode" components={components} parentName="p">{`Attribute`}</MDXTag>{` component displays the `}<MDXTag name="inlineCode" components={components} parentName="p">{`name`}</MDXTag>{` and `}<MDXTag name="inlineCode" components={components} parentName="p">{`value`}</MDXTag>{` of an `}<MDXTag name="inlineCode" components={components} parentName="p">{`Attribute`}</MDXTag>{` model. If this `}<MDXTag name="inlineCode" components={components} parentName="p">{`Attribute`}</MDXTag>{` model is part of a `}<MDXTag name="inlineCode" components={components} parentName="p">{`Character`}</MDXTag>{`, it will also display any applicable `}<MDXTag name="inlineCode" components={components} parentName="p">{`Effect`}</MDXTag>{` modifiers.`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`Note`}</MDXTag>{`: You can hover your mouse over any of the modifier displays to see `}<MDXTag name="em" components={components} parentName="p">{`which effects`}</MDXTag>{` caused that modifier to be applied.`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const character = CharacterModel.create({\n    attributes: [\n      { name: \'Strength\', value: 4 },\n      { name: \'Dexterity\', value: 3 },\n      { name: \'Stamina\', value: 4 },\n      { name: \'Charisma\', value: 3 },\n    ],\n    items: [\n      {\n        equipped: true,\n        name: \'Belt of Dwarven Strength\',\n        effects: [{ targetId: \'Strength\', modifier: 2 }],\n      },\n      {\n        equipped: true,\n        name: \"Potion: Eagle\'s Splendor\",\n        effects: [{ targetId: \'Charisma\', modifier: 2 }],\n      },\n    ],\n    traits: [\n      {\n        name: \'Half Giant\',\n        effects: [{ targetId: \'Strength\', modifier: 4 }],\n      },\n    ],\n    spells: [\n      {\n        isActive: true,\n        name: \'Curse: Rotting Flesh\',\n        effects: [\n          { targetId: \'Stamina\', modifier: -2 },\n          { targetId: \'Charisma\', modifier: -2 },\n        ],\n      },\n    ],\n  })\n  return (\n    <>\n      <h2>Dexterity</h2>\n      <p>No modifiers.</p>\n      <Attribute model={character.attributes.findBy(\'name\', \'Dexterity\')} />\n      <Attribute\n        model={character.attributes.findBy(\'name\', \'Dexterity\')}\n        rating\n      />\n      <h2>Strength</h2>\n      <p>+2 from an equipped Item, +4 from a Trait</p>\n      <Attribute model={character.attributes.findBy(\'name\', \'Strength\')} />\n      <Attribute\n        model={character.attributes.findBy(\'name\', \'Strength\')}\n        rating\n      />\n\n      <h2>Stamina</h2>\n      <p>-2 from a Curse</p>\n      <Attribute model={character.attributes.findBy(\'name\', \'Stamina\')} />\n      <Attribute\n        model={character.attributes.findBy(\'name\', \'Stamina\')}\n        rating\n      />\n\n      <h2>Charisma</h2>\n      <p>+2 from an equipped Item, -2 from a Curse</p>\n      <Attribute model={character.attributes.findBy(\'name\', \'Charisma\')} />\n      <Attribute\n        model={character.attributes.findBy(\'name\', \'Charisma\')}\n        rating\n      />\n    </>\n  )\n}'} __scope={{props: this ? this.props : props,Attribute,AttributeModel,CharacterModel}}>
  {() => {
    const character = CharacterModel.create({
      attributes: [
        { name: 'Strength', value: 4 },
        { name: 'Dexterity', value: 3 },
        { name: 'Stamina', value: 4 },
        { name: 'Charisma', value: 3 },
      ],
      items: [
        { equipped: true, name: 'Belt of Dwarven Strength', effects: [{ targetId: 'Strength', modifier: 2 }] },
        { equipped: true, name: 'Potion: Eagle\'s Splendor', effects: [{ targetId: 'Charisma', modifier: 2 }] },
      ],
      traits: [
        { name: 'Half Giant', effects: [{ targetId: 'Strength', modifier: 4 }] },
      ],
      spells: [
        { isActive: true, name: 'Curse: Rotting Flesh', effects: [
          { targetId: 'Stamina', modifier: -2 },
          { targetId: 'Charisma', modifier: -2 },
        ] },
      ],
    })
    return (<>
      <h2>Dexterity</h2>
      <p>No modifiers.</p>
      <Attribute model={character.attributes.findBy('name', 'Dexterity')} />
      <Attribute model={character.attributes.findBy('name', 'Dexterity')} rating />
  <h2>Strength</h2>
  <p>+2 from an equipped Item, +4 from a Trait</p>
  <Attribute model={character.attributes.findBy('name', 'Strength')} />
  <Attribute model={character.attributes.findBy('name', 'Strength')} rating />

  <h2>Stamina</h2>
  <p>-2 from a Curse</p>
  <Attribute model={character.attributes.findBy('name', 'Stamina')} />
  <Attribute model={character.attributes.findBy('name', 'Stamina')} rating />

  <h2>Charisma</h2>
  <p>+2 from an equipped Item, -2 from a Curse</p>
  <Attribute model={character.attributes.findBy('name', 'Charisma')} />
  <Attribute model={character.attributes.findBy('name', 'Charisma')} rating />
</>)
  }}
</Playground>
           </MDXTag>
  }
}
  